import { createGlobalState } from "react-hooks-global-state";

const { setGlobalState, useGlobalState } = createGlobalState({
  open: false,
  message: "",
  type: "error",
  auth: [],
  selectedIdBottomBar: 1,
  admin: false,
  numberNotifications: 0,
});

export { setGlobalState, useGlobalState };
